/** Preset sizes for draggable/resizable modals (width × height in px). */
export enum ModalSizeE {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  TALL = 'tall',
  /** Ticket details, open new ticket, etc. */
  TICKET_DETAIL = 'ticket_detail',
  /** Column picker for Tickets section. */
  COLUMN_PICKER = 'column_picker',
  /** Column picker for Schedule section (narrower). */
  COLUMN_PICKER_SCHEDULE = 'column_picker_schedule',
  /** Reassign, share, confirmations. */
  REASSIGN = 'reassign',
  /** Close ticket confirmation. */
  CLOSE_TICKET = 'close_ticket',
  /** Attachments, view attachments. */
  ATTACHMENTS = 'attachments',
  /** Add attachment modal. */
  ADD_ATTACHMENT = 'add_attachment',
  /** Delete attachment confirmation. */
  DELETE_ATTACHMENT = 'delete_attachment',
  /** Approve attachment confirmation. */
  APPROVE_ATTACHMENT = 'approve_attachment',
  /** Request override approval. */
  REQUEST_OVERRIDE_APPROVAL = 'request_override_approval',
  /** Import schedule. */
  IMPORT_SCHEDULE = 'import_schedule',
  /** Release notes, user info. */
  RELEASE_NOTE = 'release_note',
  /** View attached schedule files. */
  VIEW_SCHEDULE_FILES = 'view_schedule_files',
}
